import { useEffect, useState } from 'react';
import {
  signIn as authSignIn,
  signOut as authSignOut,
  confirmSignIn,
  fetchAuthSession,
  getCurrentUser,
  fetchUserAttributes
} from 'aws-amplify/auth';
import { toast } from "react-toastify";

const defaultAuthDataParams = {
  getUser: true,
  getAttr: false,
  getCogGroups: false
}

export const useAuthData = (props) => {
  const [ authData, setAuthData ] = useState(null);
  
  useEffect(() => {
    getAuthData(props).then(ret => {
      setAuthData(ret);
    });
  }, []);

  return authData;
}

export async function getAuthData(params=defaultAuthDataParams) {
  const { getUser, getAttr, getCogGroups } = params;
  let ret: { userName?: string; userId?: string; email?: string; name?: string; groups?: unknown } = {};
  if (getUser) {
    try {
      const { username, userId } = await getCurrentUser();
      ret.userName = username;
      ret.userId = userId;
    } catch (e) {
      console.error("getCurrentUser", e);
    }
  }
  if (getAttr) {
    try {
      const { email, name } = await fetchUserAttributes();
      ret.email = email;
      ret.name = name;
    } catch (e) {
      console.error("fetchUserAttributes", e);
    }
  }
  if (getCogGroups) {
    try {
      const { tokens } = await fetchAuthSession();

      if (tokens) {
	const groups = tokens.accessToken.payload["cognito:groups"];
	ret.groups = groups;
      }
    } catch (e) {
      console.error("fetchAuthSession", e);
    }
  }
  return ret;
}

export async function signIn(username, password) {
    try {
	const {
	    isSignedIn,
	    nextStep
	} = await authSignIn({ username, password });

	switch (nextStep.signInStep) {
	case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
	    const { missingAttributes } = nextStep;

	    const {
		isSignedIn,
		nextStep
	    } = await confirmSignIn({
		challengeResponse: 'newPassword'
	    });
	    break;
	case 'DONE':
	    break;
	}
    } catch (e) {
      if (e.name != "UserAlreadyAuthenticatedException") {
	toast.error("Unable to sign in");
	throw e;
      } else {
	console.log("User already logged in");
      }
    }
}

export async function signOut() {
    try {
	await authSignOut();
	localStorage.clear();
    } catch (error) {
	console.log("error signing out: ", error);
    }
}
